import {ViolationModel, ViolationSeverity} from '../models/CartSummary/Violation.model';
import {ViolationOtherTargetName} from '../models/CartSummary/ViolationOtherTarget.model';

export const calcTopThreeViolations = (violations: ViolationModel[]): ViolationModel[] => {
  const shouldDisplayViolation = (violation: ViolationModel): boolean => {
    const violationName = violation.target?.otherTarget?.name;
    return violationName === ViolationOtherTargetName.default;
  };

  return violations?.length > 0
    ? [
        ...violations.filter(
          (violation) => violation.severity === ViolationSeverity.error && shouldDisplayViolation(violation)
        ),
        ...violations.filter(
          (violation) => violation.severity === ViolationSeverity.warning && shouldDisplayViolation(violation)
        ),
      ]
        .slice(0, 3)
        .reverse()
    : [];
};
